import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientProvider } from '../providers/client.provider';
import { IdInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

@Injectable()
export class CheckPhoneUseCase implements UseCaseWithParam<string, Observable<Transaction<boolean>>> {
    constructor(private clientProvider: ClientProvider) {}

    bind(phone: string, clientCode?: IdInterface): Observable<Transaction<boolean>> {
        return this.clientProvider.existByPhone(phone, clientCode);
    }
}
